"use strict";

module.exports = require("./queries");


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/queries/index.js
 ** module id = 504
 ** module chunks = 0
 **/